<template>
    <b-form-group label="Ada Merk Perusahaan ?" v-slot="{ ariaDescribedby }" :disabled="disabled">
        <b-form-radio
            v-model="localAdaMerkPerusahaan"
            :aria-describedby="ariaDescribedby"
            name="isAdaMerkPerusahaan-radios"
            :value="true"
        >
            Ya
        </b-form-radio>
        <b-form-radio
            v-model="localAdaMerkPerusahaan"
            :aria-describedby="ariaDescribedby"
            name="isAdaMerkPerusahaan-radios"
            :value="false"
        >
            Tidak
        </b-form-radio>
    </b-form-group>
</template>

<script>
export default {
  props: {
    isAdaMerkPerusahaan: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
        localAdaMerkPerusahaan: this.isAdaMerkPerusahaan,
    };
  },
  watch: {
    isAdaMerkPerusahaan(newVal) {
      this.localAdaMerkPerusahaan = newVal;
    },
    localAdaMerkPerusahaan(newVal) {
      this.$emit("isAdaMerkPerusahaan", newVal);
    }
  }
};
</script>
